<template>
    <div v-if="hasAccess">
        <div class="max-w-sm mx-auto p-4" v-if="reportData && !reportData.completed">
            <incident-and-deviation
                    v-if="report === 'incident-deviation' && reportData !== false"></incident-and-deviation>
            <daily-flight-performance
                    v-if="report === 'daily-flight' && reportData !== false"></daily-flight-performance>
            <fatigue v-if="report === 'fatigue'"></fatigue>
            <performance-review v-if="report === 'performance-review'"></performance-review>
            <occupational-accident v-if="report === 'occupational-accident'"></occupational-accident>
        </div>

        <div v-else>
            <top-nav-bar :goto="'/reports/' + $route.params.report"></top-nav-bar>
            <empty :visible="true">
                This report has been completed and can not be edited.
            </empty>
        </div>
    </div>
</template>

<script>
    import IncidentAndDeviation from '@/partials/reports/IncidentAndDeviation.vue'
    import DailyFlightPerformance from '@/partials/reports/DailyFlightPerformance.vue'
    import Fatigue from '@/partials/reports/Fatigue.vue'
    import OccupationalAccident from '@/partials/reports/OccupationalAccident.vue'
    import PerformanceReview from '@/partials/reports/PerformanceReview.vue'
    import CanAccessView from "../mixins/CanAccessView";

    export default {
        mixins: [CanAccessView],
        components: {
            IncidentAndDeviation,
            DailyFlightPerformance,
            Fatigue,
            OccupationalAccident,
            PerformanceReview
        },

        data() {
            return {
                report: null,
                reportData: false,
                reports: {},
                routes: {},
                accidentPlaces: {},
                injuries: {},
                flights: {},
                factors: {},
            }
        },

        mounted() {
            this.$api('hr').get(`reports/${this.$route.params.report}/edit`)
                .then(({data}) => {
                    this.report = data.data.report.type.slug;

                    this.reports = data.data.reports;
                    this.factors = data.data.factors;
                    this.routes = data.data.routes;
                    this.injuries = data.data.injuries;
                    this.accidentPlaces = data.data.accident_places;
                    this.flights = data.data.flights;
                    this.reportData = data.data.report;

                    this.$emit('ready', data.data.report)
                });
        }
    }
</script>
